import { Card } from "../../models/card";
import { cards } from "../../state";
import { Rock } from "../../cards/resources/rock";
import { AudioControl } from "../../audio";
import { dropCard, forceUpdate } from "../..";
export class StreamBed extends Card {
}
StreamBed.displayName = "Stream Bed";
StreamBed.artUrl = "./assets/cards/streambed.jpg";
StreamBed.effect = {
    callback: (card) => {
        let newPos = { x: card.position.x - 8, y: card.position.y - 180 };
        for (let i = 0; i < StreamBed.upgradeTier; i++) {
            const card = new Rock(newPos);
            cards.push(card);
            forceUpdate();
            dropCard(card);
        }
        AudioControl.rock.play();
    },
    description: "Take a Rock",
    needsFeedback: false,
};
